import React from "react";
import { Skeleton } from "antd";
import {
  ChartCard,
  ChartControls,
  ChartContainer,
  EmptyState,
  EmptyStateText,
} from "./styles";
import { ProfitChartSectionProps } from "./types";
import DateRangePicker from "../../../commonComponents/DateRangePicker";
import DateSelector from "../../../commonComponents/DateSelector";
import KeyMetricsSelector from "../../../commonComponents/KeyMetricSelector";
import ChartSelection from "../../../commonComponents/ChartSelection";
import BarLineChart from "../../../commonComponents/BarLineChart";
import { METRIC_OPTIONS, EMPTY_STATE_MESSAGES } from "./constants";

const ProfitChart: React.FC<ProfitChartSectionProps> = ({
  profitData,
  selectedDateRange,
  chartType,
  metricOption,
  isLoading,
  onDateRangeChange,
  onDateSelect,
  onMetricChange,
  onChartTypeChange,
}) => {
  return (
    <ChartCard>
      <ChartControls>
        <DateRangePicker
          selectedDateRange={selectedDateRange}
          onDateRangeChange={range => {
            onDateRangeChange(range);
          }}
        />
        <DateSelector onDateSelect={onDateSelect} />
        <KeyMetricsSelector
          options={METRIC_OPTIONS}
          onSelectionChange={option => onMetricChange(option)}
        />
        <ChartSelection onChange={type => onChartTypeChange(type)} />
      </ChartControls>

      <ChartContainer>
        {isLoading ? (
          <Skeleton active paragraph={{ rows: 8 }} />
        ) : profitData?.byCategory && profitData.byCategory.length > 0 ? (
          <BarLineChart
            data={profitData.byCategory}
            chartType={chartType}
            xKey="category"
            yKey={metricOption}
            valueKey={metricOption}
            isLoading={isLoading}
          />
        ) : (
          <EmptyState>
            <EmptyStateText>{EMPTY_STATE_MESSAGES.noProfitData}</EmptyStateText>
          </EmptyState>
        )}
      </ChartContainer>
    </ChartCard>
  );
};

export default ProfitChart;
